import _ from 'lodash';

import { IColorControlServerMode } from './color-control-server-mode.interface';
import { ColorUtils } from '../color.utils';

export class ColorControlServerTemperatureMode
  implements IColorControlServerMode {
  public statusPayload = ['ColorTemperatureMireds'];
  public setColorMethod = 'MoveToColorTemperature';

  public computateColor = (state: any) => {
    const colorTemperatureMireds: number = <number> _.get(
      state,
      'colorTemperatureMireds'
    );
    if (colorTemperatureMireds != null) {
      const colorTemp = 1000000 / colorTemperatureMireds;
      return ColorUtils.KtoRGB(colorTemp);
    }
    return null;
  };

  public computateColorName = (state: any) => {
    const colorTemperatureMireds: number = <number> _.get(
        state,
        'colorTemperatureMireds'
    );
    if (colorTemperatureMireds != null) {
        const colorTemp = 1000000 / colorTemperatureMireds;
        return ColorUtils.KtoColor(colorTemp);
    }
    return '';
  };

  public buildPayload = (rgb: any) => {
    const k = ColorUtils.RGBtoK(rgb.r, rgb.g, rgb.b);
    return {
      ColorTemperatureMireds: k === 0 ? 0 : 1000000 / k,
      TransitionTime: 50
    };
  };

  public getEffectColor = (params: any) => {
    return this.computateColor({
      colorTemperatureMireds: params.ColorTemperatureMireds
    });
  };

  public getEffectColorName = (params: any) => {
    return this.computateColorName({
        colorTemperatureMireds: params.ColorTemperatureMireds
    });
  };
}
